import React from 'react'

import {
    Checkbox as MuiCheckbox,
    CheckboxProps as MuiCheckboxProps,
    FormControlLabelProps,
    FormControlLabel,
    FormGroup,
} from '@mui/material'
import { useController, FieldValues, UseControllerProps } from 'react-hook-form'

type Props<T extends FieldValues = FieldValues> = Pick<
    UseControllerProps<T>,
    'rules' | 'shouldUnregister' | 'defaultValue' | 'name'
> &
    Pick<FormControlLabelProps, 'label' | 'sx'> &
    MuiCheckboxProps

// React.forwardRef: See ControlledTextField comment
export const Checkbox = React.forwardRef(function MuiRhfCheckbox<T extends FieldValues>(
    { rules, shouldUnregister, defaultValue, name, label, sx, onChange, ...checkboxProps }: Props<T>,
    _ref: React.ForwardedRef<unknown>,
) {
    const {
        field: { ref, value, ...restFieldProps },
        // fieldState, // Errors need a FormControl and FormHelperText, but how to handle multiple checkboxes?
    } = useController<T>({ rules, shouldUnregister, defaultValue, name })

    return (
        <FormGroup row>
            <FormControlLabel
                sx={sx}
                control={
                    <MuiCheckbox
                        {...checkboxProps}
                        {...restFieldProps}
                        onChange={(e, c) => {
                            onChange?.(e, c)
                            restFieldProps.onChange(e, c)
                        }}
                        checked={!!value}
                        inputRef={ref}
                    />
                }
                label={label}
            />
        </FormGroup>
    )
})

export default Checkbox
export { Checkbox as MuiRhfCheckbox }
export type { Props as CheckboxProps, Props as MuiRhfCheckboxProps }
